import { makeVar } from '@apollo/client'
import { DisplayTanks } from 'utils/constants'

const stationsVar = makeVar({
  'PORTFOLIO_BENCHMARK': [],
  'PERIOD_ANALYSIS': [],
  'COMPETITOR_ANALYSIS': [],
  'KEY_PERFORMANCE_METRICS': [],
  'STOCK_AND_DELIVERIES': [],
})

const fuelGradesVar = makeVar({
  'PORTFOLIO_BENCHMARK': [],
  'PERIOD_ANALYSIS': [],
  'COMPETITOR_ANALYSIS': [],
  'KEY_PERFORMANCE_METRICS': [],
  'STOCK_AND_DELIVERIES': [],
})

const currentPeriodDateVar = makeVar({
  'PORTFOLIO_BENCHMARK': { from: null, to: null },
  'PERIOD_ANALYSIS': { from: null, to: null },
  'COMPETITOR_ANALYSIS': { from: null, to: null },
  'KEY_PERFORMANCE_METRICS': { from: null, to: null },
  'STOCK_AND_DELIVERIES': { from: null, to: null },
})
const previousPeriodDateVar = makeVar({
  'PORTFOLIO_BENCHMARK': { from: null, to: null },
  'PERIOD_ANALYSIS': { from: null, to: null },
  'COMPETITOR_ANALYSIS': { from: null, to: null },
  'KEY_PERFORMANCE_METRICS': { from: null, to: null },
  'STOCK_AND_DELIVERIES': { from: null, to: null },
})

const metricVar = makeVar({
  'PORTFOLIO_BENCHMARK': 'retail_fuel_volume_sales_for_computing_margin',
  'PERIOD_ANALYSIS': 'retail_fuel_volume_sales_for_computing_margin',
  'COMPETITOR_ANALYSIS': 'retail_fuel_volume_sales_for_computing_margin',
  'STOCK_AND_DELIVERIES': 'retail_fuel_volume_sales_for_computing_margin',
  'KEY_PERFORMANCE_METRICS': {
    volume: [
      'total_fuel_volume_sales',
      'retail_fuel_volume_sales_for_computing_margin',
      'bunkered_fuel_volume_sales',
      'consumer_fuel_volume_sales',
      'fuel_card_fuel_volume_sales',
    ],
    margin: ['gross_margin', 'net_margin'],
    profit: [
      'retail_gross_sales_ex_vat_for_computing_margin',
      'gross_profit',
      'net_profit',
      'business_profit',
    ],
    cost: [
      'bunkering_commissions',
      'cost_price',
      'total_fees',
      'retail_blended_cost',
    ],
    num_retail_transactions: true,
    avg_retail_fill_up: true,
  },
})

const timeResolutionVar = makeVar({
  'PORTFOLIO_BENCHMARK': 'Daily',
  'PERIOD_ANALYSIS': 'Daily',
  'COMPETITOR_ANALYSIS': 'Daily',
  'KEY_PERFORMANCE_METRICS': 'Daily',
  'STOCK_AND_DELIVERIES': 'Daily',
})

const groupByVar = makeVar({
  'PORTFOLIO_BENCHMARK': [],
  'PERIOD_ANALYSIS': [],
  'COMPETITOR_ANALYSIS': [],
  'KEY_PERFORMANCE_METRICS': [],
  'STOCK_AND_DELIVERIES': [],
})

const regionsVar = makeVar([
  'East Midlands',
  'East of England',
  'London',
  'North East',
  'North West',
  'South East',
  'South West',
  'West Midlands',
  'Yorkshire and The Humber',
  'Scotland',
  'Wales'
])
const splitByVar = makeVar({
  'PORTFOLIO_BENCHMARK': [],
  'PERIOD_ANALYSIS': [],
  'COMPETITOR_ANALYSIS': [],
  'KEY_PERFORMANCE_METRICS': ['Station', 'Fuel Grade'],
  'STOCK_AND_DELIVERIES': [DisplayTanks],
})
const activeTabVar = makeVar('PERIOD_ANALYSIS')

export {
  stationsVar,
  fuelGradesVar,
  currentPeriodDateVar,
  previousPeriodDateVar,
  metricVar,
  timeResolutionVar,
  groupByVar,
  activeTabVar,
  regionsVar,
  splitByVar,
}
